import { Card, CardBody } from "@heroui/react";
import type React from "react";

import { useAppContext } from "../../contexts/AppContext";
import { EventInfoOverlay } from "../EventInfoOverlay";
import { HeaderLeft } from "./HeaderLeft";
import { HeaderRight } from "./HeaderRight";

export const Header = ({ ...props }: React.HTMLProps<HTMLElement>) => {
  const { connected } = useAppContext();

  return (
    <header id="main-header" {...props}>
      {import.meta.env.VITE_INCLUDE_EVENT_INFO && <EventInfoOverlay />}
      <div className="flex justify-between w-full">
        <HeaderLeft />
        {!connected && (
          <div>
            <Card className="canvas-overlay-card">
              <CardBody>Disconnected</CardBody>
            </Card>
          </div>
        )}
        <HeaderRight />
      </div>
    </header>
  );
};
